module.exports = __webpack_public_path__ + "/img/SOTFL-G0uNSy.svg";